<template>
  <v-container>
    <v-row class="ma-3" align-content="center" justify="center"
      ><v-col justify="center" lg="7">
        <div class="text-center">
          <p class="text-h5">
            <span
              ><i
                >Bienvenue sur le nouveau site web de la Banque Africaine de
                Données Polliniques</i
              ></span
            >
          </p>
          <p style="color:red" class="text-h6">
            En construction
          </p>
          <v-img src="../../assets/bestiole.gif" height-min="100px"></v-img>
          <p class="text-h5">
            <span
              ><i>Welcome to the new African Pollen Database web site</i></span
            >
          </p>
          <p style="color:red" class="text-h6">
            Under construction
          </p>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "WelcomePage",
};
</script>

<style>
a:link {
  color: #2b2118;
}
a:visited {
  color: #2b2118;
}
</style>